// The credits/tokens system has been retired. These components are kept as
// no-op renderers so every place that still references them simply shows
// nothing — no balance badge, no per-action cost labels.

export default function TokenBadge() {
  return null;
}

// Small cost indicator that used to appear before an AI action.
export function TokenCost() {
  return null;
}
